
<div class="container-fluid p-3">

  <div class="d-flex justify-content-between align-items-center mb-3">

    <h3 class="mb-0">
      Update Upload Documents
    </h3>

    <button class="btn-close"
            mat-dialog-close>
    </button>

  </div>

  <hr>

  <!-- Table -->

  <div class="table-responsive">

    <table class="table table-bordered table-striped">

      <thead>

        <tr>

          <th>Sr.No</th>

          <th>Document Type</th>

          <th>Document Name</th>

          <th>Original File</th>

          <th>Uploaded Date</th>

          <th>Actions</th>

        </tr>

      </thead>

      <tbody>

        <tr *ngFor="let row of dataSource; let i = index">

          <td>{{ i + 1 }}</td>

          <td>{{ row.documentType }}</td>

          <td>{{ row.documentName }}</td>

          <td>{{ row.originalFileName }}</td>

          <td>{{ row.createdOn | date:'dd/MM/yyyy' }}</td>

          <td>

            <!-- Upload Button -->

            <button class="btn btn-sm btn-primary"
                    (click)="onUploadDocument(row)">

              <i class="bi bi-upload"></i>

            </button>

            <!-- Download Button -->

            <button class="btn btn-sm btn-success">

              <i class="bi bi-download"></i>

            </button>

          </td>

        </tr>

        <tr *ngIf="dataSource.length === 0">

          <td colspan="6"
              class="text-center">

            No Documents Found

          </td>

        </tr>

      </tbody>

    </table>

  </div>

</div>

